import { render, staticRenderFns } from "./relatorioContratoContratos.vue?vue&type=template&id=54e8eff0"
import script from "./relatorioContratoContratos.vue?vue&type=script&lang=js"
export * from "./relatorioContratoContratos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports